export default function isUrlValid(url) {
  const re =
    /(http|https):///;
  return re.test(String(url).toLowerCase());
}
